<template>
  <div id="app" class="app-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
body {
  background: linear-gradient(to bottom, #e1f6fe, #b5e0f5);
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.app-container {
  /* 默认为100%宽度，适合移动设备 */
  width: 100%;
  max-width: 390px;
  /* 最大宽度，模仿常见的手机宽度 */
  min-height: 100vh;
  /* 视口高度 */
  box-shadow: 0 0 20px #85b0b4;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue